import React from 'react';

const ContactInfoView = ({ isOpen, onClose, loanDetails }) => {
  if (!isOpen) return null; // Do not render if the modal is not open

  return (
    <div className="modal">
      <div className="modal-content border border-headerBtn ">
        <div className="flex justify-between p-4">
          <div></div>
          {/* Close button */}
          <span
            className="close md:mr-4 mr-0 -mt-0 text-black text-2xl font-bold hover:text-btnHover"
            onClick={onClose}
          >
            &times;
          </span>
        </div>
        <div className="flex items-center justify-center">
          <h2 className="md:text-2xl text-lg font-semibold md:mb-2 ">
            Contact Information
          </h2>
        </div>

        {loanDetails ? (
          <div className="p-8 pace-y-4 text-center">
            <p className=" heading lg:text-2xl text-xl">
              {loanDetails.lc_applicant}
            </p>
            <p>Contact Number: {loanDetails.phone}</p>
            <p>Email: {loanDetails.email}</p>
            {/* <p>Address: {loanDetails.location}</p> */}
          </div>
        ) : (
          <p>Loading loan details...</p>
        )}
        {/* Close button */}
        <div className="flex items-center justify-center mb-6">
          <button
            onClick={onClose}
            type="button"
            className="border-headerBtn border-2 text-headerBtn text-xs md:text-sm md:py-2 py-1 md:px-8 px-4 rounded-lg hover:bg-btnHover hover:text-white "
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoView;
